







import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'ContetntNotAvalaible'
})
export default class App extends Vue {
  @Prop() error!: any
}

